module.exports = __webpack_public_path__ + "static/media/peughouia.78a3f086.png";